import styled from 'styled-components';
import { CardContent } from '@prisjakt/ui/card';
import { CaptionText } from '@prisjakt/ui/text/variants';
import { layout } from 'src/components/base';

export const StyledFooter = styled(CardContent)`
  && {
    padding-top: 0;
    justify-content: end;
    gap: ${layout.measurements.spacing075};
  }
`;

export const StyledStoreCountLink = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;

export const StyledLink = styled(CaptionText)`
  && {
    text-decoration: underline;

    &:hover {
      color: ${p => p.theme.text.callToAction};
    }
  }
`;
